"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Routes = void 0;
var _reactRouterDom = require("react-router-dom");
var _constants = require("../../constants");
var _CategoryPage = require("../CategoryPage");
var _LandingPage = require("../LandingPage");
var _SearchResultPage = require("../SearchResultPage");
var _jsxRuntime = require("react/jsx-runtime");
const Routes = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_reactRouterDom.Routes, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
                path: _constants.SiteMap.Home.path,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LandingPage.LandingPage, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
                path: _constants.SiteMap.Search.path,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SearchResultPage.SearchResultPage, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
                path: _constants.SiteMap.Category.path,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CategoryPage.CategoryPage, {})
            })
        ]
    });
exports.Routes = Routes;
